"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOperation = exports.performTransform = exports.validateTransform = exports.validateConfig = void 0;
const common_1 = require("@finley-technologies/common");
const errorUtils_1 = require("./errorUtils");
const helpers_1 = require("./helpers");
const sanitizeTransform = __importStar(require("./sanitize-transform"));
const virtualSheetConfiguration_1 = require("./virtualSheetConfiguration");
const validateConfig = (transformation) => {
    const { virtualSheet, fields } = transformation;
    return (0, virtualSheetConfiguration_1.validateVirtualSheetConfiguration)({ virtualSheet, fields });
};
exports.validateConfig = validateConfig;
const getOutputDataTapeValues = (transformation) => {
    const errors = (0, exports.validateConfig)(transformation);
    if (errors.length) {
        return { isValid: false, errors };
    }
    // output tape definition is decided by sanitize.
    // lets call sanitize helper to get the output tape definition.
    const sanitizeTransformation = {
        operation: 'sanitize',
        srcDataTape: {
            baseFields: transformation.fields,
            delimiter: ',',
        },
        // Note:we do not want to sanitize field names
        // to give flexibility to user to decorate them with special characters.
        // if they wanted sanitized names, they can always specify fields names as such.
        sanitizeFieldNames: false,
    };
    const data = (0, helpers_1.getSanitizeTransformOpOutputDataTape)(sanitizeTransformation);
    return { isValid: true, data };
};
const validateTransform = (transformation) => {
    try {
        const res = getOutputDataTapeValues(transformation);
        return res;
    }
    catch (error) {
        const errors = [];
        errors.push({
            type: 'metadataValidation',
            message: error instanceof Error
                ? error.message
                : 'Unexpected Error in pyXlsxVirtualSheet2Csv:getOutputDataTape',
        });
        return { isValid: false, errors };
    }
};
exports.validateTransform = validateTransform;
const performTransform = async ({ buffersWithExtensions, transformation, csvParser, pyXlsxVirtualSheet2CsvExtractor, }) => {
    try {
        (0, common_1.finleyAssert)(pyXlsxVirtualSheet2CsvExtractor, 'pyXlsxVirtualSheet2CsvExtractor is required');
        (0, common_1.finleyAssert)(buffersWithExtensions.length === 1, 'Only one data tape is supported');
        const validationResult = (0, exports.validateConfig)(transformation);
        (0, common_1.finleyAssert)(validationResult.length === 0, `Invalid transformation params: [${validationResult.join(', ')}]`);
        const extractedCsvResult = await pyXlsxVirtualSheet2CsvExtractor({
            extractionParams: {
                sheets: transformation.sheets,
                virtualSheet: transformation.virtualSheet,
            },
            excelBuffer: buffersWithExtensions[0],
        });
        if (!extractedCsvResult.isValid) {
            return extractedCsvResult;
        }
        const sanitizedCsvResult = await sanitizeTransform.transformOperation.performTransform({
            dataTapeBuffers: [extractedCsvResult.data.outputBuffer],
            transformation: {
                operation: 'sanitize',
                sanitizeFieldNames: false,
                srcDataTape: {
                    baseFields: transformation.fields,
                    delimiter: ',',
                },
            },
            csvParser,
        });
        return sanitizedCsvResult;
    }
    catch (error) {
        return (0, errorUtils_1.convertErrorToTapeFailureResult)(error, 'pyXlsxVirtualSheet2Csv: ');
    }
};
exports.performTransform = performTransform;
exports.transformOperation = {
    operation: 'pyXlsxVirtualSheet2Csv',
    validateTransform: exports.validateTransform,
    performTransform: exports.performTransform,
};
//# sourceMappingURL=pyXlsxVirtualSheet2Csv-transform.js.map